import SimpleGpTable from 'thsc-ifind-stock-f9/packages/components/SimpleGpTable.vue';
import CommonTable from 'thsc-ifind-stock-f9/packages/common/CommonTable.vue';

export default {
  SimpleGpTable,
  CommonTable,
};
